import { Alert, Flex } from "antd";
import { observer } from "mobx-react-lite";

import { useStores } from "stores";
import { ActionRequestNotifier } from "../ActionRequestNotifier";
import { RETRY_TX_DELAY } from "utils/envConstants";
import { getTimeDifferenceInMs, isStatusIncluded } from "utils";
import { BID_REQUEST_STATUS_ENUM, BidEntity } from "interfaces";

interface IProps {
  data: BidEntity;
}

export const BidTopAlerts = observer((props: IProps) => {
  const { data } = props;
  const { status, network } = data;
  const { user } = useStores();

  const { isOperator } = user.roles;

  if (
    isStatusIncluded(status, [BID_REQUEST_STATUS_ENUM.CANCELED_REFUNDING, BID_REQUEST_STATUS_ENUM.AML_FAILED_REFUNDING])
  ) {
    const retryTxDelayInMs = parseInt(RETRY_TX_DELAY) * 60 * 1000;
    const statusDelayInMs = getTimeDifferenceInMs(data.statusDate);
    const isStatusDelayed = statusDelayInMs > retryTxDelayInMs;
    return (
      <Flex vertical gap="middle">
        {isStatusDelayed && isOperator && (
          <Alert
            message={"Транзакция обрабатывается"}
            description={`Транзакция не может быть отправлена из-за недостаточного баланса и высокой загрузки сети, повторная попытка происходит каждые ${parseInt(
              RETRY_TX_DELAY
            )} минут. Загрузка сети может снизится или можете пополнить баланс ${network} транзитного кошелька.`}
            type="warning"
            showIcon
          />
        )}
      </Flex>
    );
  }

  if (status !== BID_REQUEST_STATUS_ENUM.EXPIRED) {
    return <ActionRequestNotifier />;
  }
});
